import { render, staticRenderFns } from "./OverduePaymentsBreakdown.vue?vue&type=template&id=788bddbb&scoped=true"
import script from "./OverduePaymentsBreakdown.vue?vue&type=script&lang=js"
export * from "./OverduePaymentsBreakdown.vue?vue&type=script&lang=js"
import style0 from "./OverduePaymentsBreakdown.vue?vue&type=style&index=0&id=788bddbb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788bddbb",
  null
  
)

export default component.exports